import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { updatesService } from '../services/api';
import { scheduleIdle } from '../utils/scheduleIdle';

const InfoUpdatesContext = createContext(null);

export const InfoUpdatesProvider = ({ children }) => {
    const { user } = useAuth();
    const [hasUnreadUpdates, setHasUnreadUpdates] = useState(false);

    const loadUnread = useCallback(async () => {
        if (!user) {
            setHasUnreadUpdates(false);
            return;
        }
        try {
            const response = await updatesService.checkUnreadUpdates();
            setHasUnreadUpdates(response.data.hasUnread);
        } catch {
            // silently ignore
        }
    }, [user]);

    useEffect(() => {
        return scheduleIdle(loadUnread, 1600);
    }, [loadUnread]);

    const markUpdatesRead = useCallback(async () => {
        if (!user || !hasUnreadUpdates) return;
        setHasUnreadUpdates(false);
        try {
            await updatesService.markUpdatesRead();
        } catch {
            // silently ignore
        }
    }, [user, hasUnreadUpdates]);

    return (
        <InfoUpdatesContext.Provider value={{ hasUnreadUpdates, markUpdatesRead, refreshUnread: loadUnread }}>
            {children}
        </InfoUpdatesContext.Provider>
    );
};

export const useInfoUpdates = () => useContext(InfoUpdatesContext);
